import { render, staticRenderFns } from "./messenger-layout.vue?vue&type=template&id=533cbfb0&scoped=true&"
import script from "./messenger-layout.vue?vue&type=script&lang=js&"
export * from "./messenger-layout.vue?vue&type=script&lang=js&"
import style0 from "./messenger-layout.vue?vue&type=style&index=0&id=533cbfb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533cbfb0",
  null
  
)

export default component.exports